import React, { useRef, useState } from 'react';
import { bool, func, string, node } from 'prop-types';
import classNames from 'classnames';
import { Popover } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { MODAL_BASE_CLASS_NAME } from '../../utils/constants';
import { EventTypes } from '../../utils/events/types';
import { contextConnect } from '../Context';
import { HamburgerBtn } from '../ui/HamburgerBtn';
import { HeartBtn } from '../ui/HeartBtn';
import CollectTooltip from '../CollectTooltip';
import eventsReporter from '../../utils/events/reporter';
import Menu from './Menu';

const Collections = ({
    inspireVariant = false,
    isCollected = false,
    menuPosition = Popover.POSITIONS.TOP_LEFT,
    allowMenuOverflow,
    onCollectionClickedCallback,
    tooltipClassName,
    heartButtonClassName,
    hamburgerButtonClassName,
    hamburgerIcon,
    heartIcon,
    popoverContainerClassName
}) => {
    const [modalImported, setModalImported] = useState(false);
    const createCollectionModalRef = useRef(null);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const shouldPreventCloseAction = (e) => {
        // "isClickedInModal" is required since it prevents clicks in the modal from closing it due
        // to Popover's. "isCloseBtnClicked" is required since we do want to close the Modal when click on the
        // X Button.
        if (isClickedInModal(e) && !isCloseBtnClicked(e)) {
            return true;
        }
    };

    const isClickedInModal = (e) => e.target.closest(`.${MODAL_BASE_CLASS_NAME}`);

    const isCloseBtnClicked = (e) => e.target.closest('.modal-content-close');

    const onClick = async() => {
        importModal();
        eventsReporter.report(EventTypes.menu.clicked);
    };

    const importModal = async() => {
        if (modalImported) {return;}

        const CreateCollectionModal = await import(
            /* webpackChunkName: 'CreateCollectionModal' */'./Menu/CreateCollectionModal'
            );
        createCollectionModalRef.current = CreateCollectionModal.default;
        setModalImported(true);
    };

    const shouldShowHamburgerMenu = !inspireVariant;
    const shouldShowInspireButton = inspireVariant;

    return (
        <div className="flex">
            <Popover shouldPreventCloseAction={shouldPreventCloseAction}
                position={menuPosition}
                allowOverflow={allowMenuOverflow}
                containerClassName={classNames('collect-popover-container', popoverContainerClassName)}
                appendToBody={false}
                onOpen={() => setIsPopoverOpen(true)}
                onClose={() => setIsPopoverOpen(false)}
                content={
                    <Menu onCollectionClickedCallback={onCollectionClickedCallback}
                        CreateCollectionModal={createCollectionModalRef.current}/>
                }>
                {shouldShowHamburgerMenu && (
                    <CollectTooltip content={<I18n k="collect_package.save_in"/>} tooltipClassName={tooltipClassName} showTooltip={!isPopoverOpen}>
                        <HamburgerBtn hamburgerIcon={hamburgerIcon} onClick={onClick} className={hamburgerButtonClassName}/>
                    </CollectTooltip>
                )}
                {shouldShowInspireButton && (
                    <HeartBtn heartIcon={heartIcon} inspireVariant filled={isCollected} onClick={onClick} className={heartButtonClassName}/>
                )}
            </Popover>
        </div>
    );
};

Collections.propTypes = {
    inspireVariant: bool,
    isCollected: bool,
    menuPosition: string,
    allowMenuOverflow: bool,
    onCollectionClickedCallback: func,
    tooltipClassName: string,
    heartButtonClassName: string,
    hamburgerButtonClassName: string,
    hamburgerIcon: node,
    heartIcon: node,
    popoverContainerClassName: string
};

export { Collections };
export default contextConnect()(Collections);
